module.exports = __webpack_public_path__ + "static/media/adaptacion del arco - sin adaptado.b698a816.png";